module.exports = {"msg":{"yay":"Yay!","oops":"Oops!","warning":"Warning","somethingWentWrong":"Something went wrong.","invalidImage":"The image you are trying to upload seem to be too big. Please try with another one."}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en.json
// module id = 2014
// module chunks = 0